var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurtains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87 5h-74c-3.3008 0-6 2.6992-6 6v77c0 3.8984 3.1016 7 7 7 2 0 3.6992-0.80078 5-2.1016 1.3008 1.3008 3 2.1016 5 2.1016 3.8984 0 7-3.1016 7-7v-5h38v5c0 3.8984 3.1016 7 7 7 2 0 3.6992-0.80078 5-2.1016 1.3008 1.3008 3 2.1016 5 2.1016 3.8984 0 7-3.1016 7-7v-77c0-3.3008-2.6992-6-6-6zm-70 83c0 1.6016-1.3008 3-3 3s-3-1.3984-3-3v-67h6zm10 0c0 1.6016-1.3008 3-3 3s-3-1.3984-3-3v-67h6zm21-40h-4c-1.1016 0-2 0.89844-2 2s0.89844 2 2 2h4v27h-17v-58h17zm21 31h-17v-27h4c1.1016 0 2-0.89844 2-2s-0.89844-2-2-2h-4v-27h17zm10 9c0 1.6016-1.3008 3-3 3s-3-1.3984-3-3v-67h6zm10 0c0 1.6016-1.3008 3-3 3s-3-1.3984-3-3v-67h6zm0-71h-78v-6c0-1.1016 0.89844-2 2-2h74c1.1016 0 2 0.89844 2 2z",
    fill: "#c39a36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtains);
export default __webpack_public_path__ + "static/media/curtains.6e76ebfa.svg";
export { ForwardRef as ReactComponent };